import { Component } from '@angular/core';

/**
 * Dots Loader Component
 * 
 * Displays an animated three-dot loader with fast animation
 */
@Component({
  selector: 'app-dots-loader',
  templateUrl: './dots-loader.component.html',
  styleUrls: ['./dots-loader.component.scss']
})
export class DotsLoaderComponent {
  constructor() {}
}
